import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import React from "react";
import { tokens } from '../../../assets/tokens'

// El contenedor, la cabecera y los botones los pone ActionDialog; aquí solo el label del campo
export const ModalStyled = styled.div`
  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${tokens.color.text.label};
  }
`

export const ButtonExport = styled(props => <Button {...props}/>)`
    /* Sin margen propio: el hueco lo da el gap de la cabecera y el último botón llega al borde */
    margin-right: 0 !important;
`
